import { StyleSheet } from 'react-native'
import type { Theme } from '../../../src/theme/getTheme'
import { BRACKET_BOX_W, BRACKET_TROPHY_SIZE } from './knockoutBracket.constants'

export const getBracketCenterStyles = (theme: Theme) =>
  StyleSheet.create({
    column: {
      width: BRACKET_BOX_W + 24,
      alignItems: 'center',
    },
    trophyWrap: {
      width: BRACKET_TROPHY_SIZE,
      height: BRACKET_TROPHY_SIZE,
      alignItems: 'center',
      justifyContent: 'center',
    },
    trophyMark: {
      position: 'absolute',
      top: BRACKET_TROPHY_SIZE * 0.34,
      fontSize: 20,
      fontWeight: '800',
      color: theme.gray[400],
    },
    championLabel: {
      marginTop: 4,
      fontSize: 12,
      fontWeight: '700',
      letterSpacing: 1.5,
      color: theme.gray[400],
    },
  })
